import { CustomField } from "@/backend/models/customFields/customField";

// A choice can carry an operator-facing label that differs from the value the procedure
// consumes. When it does, show both so a `10x` probe setting stays traceable to the `0.1`
// the procedure actually uses.
export function ChoiceLabelAndValue(props: { field: CustomField }) {
  const { field } = props;

  if (!field.hasDistinctLabel()) {
    return <span className='fusa-menu-item'>{field.getLabel()}</span>;
  }

  return (
    <span className='fusa-menu-item'>
      {field.getLabel()}
      <small className='text-muted ms-1'>({field.asString()})</small>
    </span>
  );
}
